package com.cybersoftsolution.cybersoftsolutionweb.components.cards

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import kotlin.math.floor

@Composable
fun ProfileCard(
    id: String,
    parentWidth: Int,
    imageSrc: String,
    myPosition: MyPosition = MyPosition.start,
    profileData: ProfileData = ProfileData(),
    onButtonClick: () -> Unit = {},
    buttonText: String = "",
    additionalContent: @Composable () -> Unit = {},
){
    val breakpoint = rememberBreakpoint()
    var imgPosition by remember { mutableStateOf(myPosition) }
    val width by remember { mutableStateOf(parentWidth.px) }
    val height:Int by remember { mutableStateOf( floor(parentWidth.toDouble() / 2).toInt()) }

    if (isDesktop()) imgPosition = myPosition else imgPosition = MyPosition.top

    SimpleGrid(
        numColumns = numColumns(base = 1, md = 2),
        modifier = Modifier
            .fillMaxWidth(
                if(isDesktop()) width else 95.percent
            )
            .thenIf(
                condition = isDesktop(),
                other = Modifier.height(height.px)
            )
            .boxShadow(
//                offsetY = 4.px,
                blurRadius = 20.px,
                spreadRadius = 20.px,
                color = Colors.Black.copyf(alpha = 0.1f)
            )
            .margin(8.px)
            .padding(8.px)
            .backgroundColor(Colors.White)
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Colors.White
            )
            .borderRadius(15.px)

    ){
        if(imgPosition == MyPosition.start || imgPosition == MyPosition.top) {
            ProfileImage(
                imageSrc = imageSrc,
                height = height,
                myPosition = imgPosition
            )
            ProfileInfo(
                profileData = profileData,
                height = height,
                width = parentWidth,
                id = id,
                buttonText = buttonText,
                onButtonClick = onButtonClick,
                additionalContent = additionalContent,
            )
        } else {
            ProfileInfo(
                profileData = profileData,
                height = height,
                width = parentWidth,
                id = id,
                buttonText = buttonText,
                onButtonClick = onButtonClick,
                additionalContent = additionalContent,
            )
            ProfileImage(
                imageSrc = imageSrc,
                height = height,
                myPosition = imgPosition
            )
        }
    }
}



@Composable
fun ProfileInfo(
    id: String,
    profileData: ProfileData = ProfileData(),
    width: Int,
    height: Int,
    onButtonClick: () -> Unit = {},
    buttonText: String,
    additionalContent: @Composable () -> Unit = {},
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .thenIf(
                condition = isDesktop(),
                other = Modifier.height(height.px-20.px)
            )
            .padding(8.px)

    ) {

        Column(
            verticalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .fillMaxWidth()
                .thenIf(
                    condition = isDesktop(),
                    other = Modifier.height(height.px-20.px)
                )
        ) {

            Column(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()


                ) {
                    Row (
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier
                            .fillMaxWidth(80.percent)
                    ){
                        if (profileData.icon.isNotEmpty()) {
                            Image(
                                modifier = Modifier
                                    .objectFit(ObjectFit.Cover)
                                    .width(48.px)
                                    .height(48.px)
                                    .margin(right = 8.px),

                                src = profileData.icon

                            )
                        }
                        Column(
                            modifier = Modifier
                        ){
                            SpanText(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .fontStyle(FontStyle.Normal)
                                    .fontSize(18.px)
                                ,
                                text = profileData.title
                            )
                            SpanText(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .fontStyle(FontStyle.Normal)
                                    .fontSize(14.px),
                                text = profileData.subtitle

                            )
//                            MySpanText(
//                                modifier = Modifier
//                                    .fillMaxWidth(),
//                                maxLines = 1,
//                                fontSize = 18,
//                                text = profileData.title
//                            )
//                            MySpanText(
//                                modifier = Modifier
//                                    .fillMaxWidth(),
//                                fontStyle = FontStyle.Italic,
//                                maxLines = 2,
//                                fontSize = 14,
//                                text = profileData.subtitle
//                            )
                        }
                    }

                    if (buttonText.isNotEmpty()) {
                        Box(
                            contentAlignment = Alignment.CenterEnd,
                            modifier = Modifier
                                .height(28.px)
                                .fillMaxWidth(20.percent)
                        ) {

                            MyButton(
                                buttonType = MyButtonType.Primary,
                                id = "${id}Button",
                                text = buttonText,
                                fontSize = 14,
                                onClick = onButtonClick
                            )
                        }
                    }



                }

                Surface(
                    modifier = Modifier
                        .fillMaxWidth()
                        .borderRadius(50.px)
                        .height(2.px)
                        .margin(topBottom = 8.px)
                        .backgroundColor(Theme.Primary.rgb).opacity(50.percent)
                ){}
                SpanText(
                    modifier = Modifier
                        .fillMaxWidth()
                        .fontSize(14.px)
                        .opacity(50.percent)
                    ,
                    text = profileData.description
                )
            }

            Box(
                modifier = Modifier
                    .padding(bottom = 8.px)

            ) {
                additionalContent()
            }




        }


    }

}

@Composable
fun ProfileImage(
    myPosition: MyPosition,
    imageSrc: String = "",
    height: Int,
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .thenIf(
                condition = isDesktop(),
                other = Modifier.height(height.px-20.px)
            )

    ) {
        Image(
            modifier = Modifier
                .fillMaxSize()
                .borderRadius(
                )
                .thenIf(
                    condition = myPosition == MyPosition.start,
                    other = Modifier.borderRadius(
                        topLeft = 15.px,
                        bottomLeft = 15.px,
                        topRight = 0.px,
                        bottomRight = 0.px
                    )
                )
                .thenIf(
                    condition = myPosition == MyPosition.end,
                    other = Modifier.borderRadius(
                        topLeft = 0.px,
                        bottomLeft = 0.px,
                        topRight = 15.px,
                        bottomRight = 15.px
                    )

                )
                .thenIf(
                    condition = myPosition == MyPosition.top,
                    other = Modifier.borderRadius(
                        topLeft = 15.px,
                        bottomLeft = 0.px,
                        topRight = 15.px,
                        bottomRight = 0.px
                    )
                )
                .objectFit(ObjectFit.Cover),
            src = imageSrc,

            )
    }




}


enum class MyPosition{
    start,
    end,
    top,
    bottom
}

enum class MyOrientation{
    horizontal,
    vertical,
}



data class ProfileData(
    var title: String = "",
    var subtitle: String = "",
    var icon: String = "",
    var description: String= "",
)